import { BreadcrumbsKey } from 'components/page/i18n/TModules';

export const translations = {
  [BreadcrumbsKey]: {
    Home: 'Home',
    Campaigns: 'Campaigns',
    Customers: 'Customers',
    List: 'List',
    LanguageSelector: 'Language Selector',
    Preference: 'Preference',
    Rewards: 'Rewards',
    LevelUpMarketing: 'Level Up Marketing',
    Info: 'Info',
    Audience: 'Audience',
    Mechanics: 'Mechanics',
    Review: 'Review',
    RewardInfo: 'Reward Info',
    RewardMechanics: 'Reward Mechanics',
    SelectAudience: 'Select Audience'
  }
};
